import { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { BookingTimeStep } from "./BookingTimeStep";
import { api, errorMessage } from "../lib/api";

export const RescheduleSheet = ({ appointmentId, session, onClose, onSaved, onAgenda }) => {
  const [meeting, setMeeting] = useState(null);
  const [venue, setVenue] = useState(null);
  const [slot, setSlot] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!appointmentId) return undefined;
    let live = true; setSlot(null); setError("");
    api.get(`/appointments/${appointmentId}`).then(async ({ data }) => {
      const response = await api.get(`/venues/${data.venue_id}`);
      if (live) { setMeeting(data); setVenue(response.data); }
    }).catch((e) => { if (live) setError(errorMessage(e)); });
    return () => { live = false; };
  }, [appointmentId]);
  const save = async () => {
    setBusy(true); setError("");
    try {
      await api.patch(`/appointments/${appointmentId}/reschedule`, { date: slot.date, time: slot.time },
        { headers: { "X-CSRF-Token": session.csrf_token } });
      onSaved(); onClose();
    } catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <Sheet open={Boolean(appointmentId)} onOpenChange={(next) => { if (!next) onClose(); }}>
    <SheetContent side="bottom" className="hud-sheet booking-sheet" closeTestId="reschedule-close-button" data-testid="reschedule-sheet">
      <div className="sheet-grab" aria-hidden="true" /><SheetHeader><SheetTitle className="sr-only">Sposta incontro</SheetTitle></SheetHeader>
      <button type="button" className="sheet-back" onClick={() => slot ? setSlot(null) : onClose()}
        data-testid="reschedule-back">‹ Indietro</button>
      <h2 className="sheet-title" data-testid="reschedule-title">Sposta · {venue?.name || "Incontro"}</h2>
      {error && <p role="alert" className="form-error" data-testid="reschedule-error">{error}</p>}
      {venue && meeting && !slot && <BookingTimeStep venue={venue} prefill={{ participantIds: meeting.participant_ids?.length
        ? meeting.participant_ids : [meeting.presenter_id] }}
        onChoose={setSlot} onAgenda={onAgenda} />}
      {slot && <div className="booking-confirm" data-testid="reschedule-confirm">
        <p>{slot.date} · {slot.time} · {slot.participant_names?.join(", ")}</p>
        <button type="button" className="hud-button" onClick={save} disabled={busy}
          data-testid="reschedule-save">{busy ? "Salvataggio…" : "Conferma spostamento"}</button></div>}
    </SheetContent>
  </Sheet>;
};